module.exports = __webpack_public_path__ + "img/box6-14.3702f998.png";